
import {
  defineComponent,
  onMounted,
  ref,
  nextTick,
  watch,
  computed,
} from "vue";
//import { useRoute } from "vue-router";

import ApiService from "@/core/services/ApiService";
import MerchantActions from "@/components/dropdown/MerchantActions.vue";
import { MenuComponent } from "@/assets/ts/components";
import { removeModalBackdrop } from "@/core/helpers/dom";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
const NMI_CONNECTION_ID = "1";
const KONNEKTIVE_CONNECTION_ID = "2";
const LIMELIGHT_CONNECTION_ID = "3";
const USAEPAY_CONNECTION_ID = "51";

interface Filter {
  status: string;
  author: boolean;
  customer: boolean;
  notifications: boolean;
}

interface UserDetails {
  admintype: string;
  customer_id: string;
  companygroupid: string;
  adminfirstname: string;
  adminfullname: string;
  adminlastname: string;
  adminemail: string;
  admincompanyname: string;
  adminpic: string;
  adminid: string;
  adminstatus: string;
  admintitle: string;
}

export default defineComponent({
  name: "topbar",
  components: { MerchantActions },
  setup() {
    //const route = useRoute();
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const data = ref<Filter>({
      status: "1",
      author: true,
      customer: true,
      notifications: false,
    });
    const userData = ref<UserDetails>({
      admintype: "",
      customer_id: "",
      companygroupid: "",
      adminfirstname: "",
      adminfullname: "",
      adminlastname: "",
      adminemail: "",
      admincompanyname: "",
      adminpic: "",
      adminid: "",
      adminstatus: "",
      admintitle: "",
    });
    const showProgress = ref(false);

    const getUserData = async () => {
      const { data } = await ApiService.get(
        `users/accounts/${store.getters.currentUser.data.adminid}`
      );
      if (data.data[0]) {
        Object.keys(userData.value).forEach((key) => {
          if (data.data[0][key]) {
            userData.value[key] = data.data[0][key];
          }
        });
      }
    };
    const getMerchantId = computed(() => {
      return route.params.id;
    });
    onMounted(async () => {
      setTimeout(async () => {
        await getUserData();
        getOnboardProgress();
      }, 1000);
    });
    const isMerchantAccountPage = computed(() => {
      if (route.path.includes("/merchants/accounts/details")) {
        return true;
      }
      return false;
    });

    const getIsTransactionEmpty = async () => {
      let url, res;
      try {
        url = `apis/merchants?merchant_id=${getMerchantId.value}`;
        res = await ApiService.get(url);
        if (res.data.meta.total !== 0) {
          const connections = [...res.data.data];
          const nmi = connections.find(
            (conn) => conn.connection_id === NMI_CONNECTION_ID
          );
          const konnektive = connections.find(
            (conn) => conn.connection_id === KONNEKTIVE_CONNECTION_ID
          );
          const limelight = connections.find(
            (conn) => conn.connection_id === LIMELIGHT_CONNECTION_ID
          );
          const usaepay = connections.find(
            (conn) => conn.connection_id === USAEPAY_CONNECTION_ID
          );

          if (nmi !== undefined) {
            const { data } = await ApiService.get(
              `transactions/${NMI_CONNECTION_ID}?merchant_id=${getMerchantId.value}`
            );
            if (data.meta.total !== 0) {
              return false;
            }
          } else if (konnektive !== undefined) {
            const { data } = await ApiService.get(
              `transactions/${KONNEKTIVE_CONNECTION_ID}?merchant_id=${getMerchantId.value}`
            );
            if (data.meta.total !== 0) {
              return false;
            }
          } else if (limelight !== undefined) {
            const { data } = await ApiService.get(
              `transactions/${LIMELIGHT_CONNECTION_ID}?merchant_id=${getMerchantId.value}`
            );
            if (data.meta.total !== 0) {
              return false;
            }
          } else if (usaepay !== undefined) {
            const { data } = await ApiService.get(
              `transactions/${USAEPAY_CONNECTION_ID}?merchant_id=${getMerchantId.value}`
            );
            if (data.meta.total !== 0) {
              return false;
            }
          }
        }
      } catch (err) {
        return true;
      }

      return true;
    };
    const getOnboardProgress = async () => {
      onboardProgress.value = 0;

      if (isMerchantAccountPage.value) {
        let url, res;
        try {
          url = `apis/merchants?merchant_id=${getMerchantId.value}&group[category]=Portal`;
          res = await ApiService.get(url);
          if (res.data.meta.total !== 0) {
            onboardProgress.value = onboardProgress.value + 20;
          }
        } catch (err) {
          onboardProgress.value = onboardProgress.value + 0;
        }

        try {
          url = `apis/merchants?merchant_id=${getMerchantId.value}&group[category]=Gateway,Processor,Crm`;
          res = await ApiService.get(url);
          if (res.data.meta.total !== 0) {
            onboardProgress.value = onboardProgress.value + 20;
          }
        } catch (err) {
          onboardProgress.value = onboardProgress.value + 0;
        }

        const isTransactionEmpty = await getIsTransactionEmpty();
        if (!isTransactionEmpty) {
          onboardProgress.value = onboardProgress.value + 20;
        }

        try {
          url = `merchants/accounts/${getMerchantId.value}?fields=merchantProduct`;
          res = await ApiService.get(url);
          if (
            res.data.data[0].merchantProduct !== "" &&
            res.data.data[0].merchantProduct !== "[]"
          ) {
            onboardProgress.value = onboardProgress.value + 20;
          }
        } catch (err) {
          onboardProgress.value = onboardProgress.value + 0;
        }

        try {
          url = `merchants/accounts/${getMerchantId.value}?fields=checkoutPage`;
          res = await ApiService.get(url);
          const checkout = JSON.parse(res.data.data[0].checkoutPage);
          if (
            checkout.cancel_url !== "" &&
            checkout.cancel_url !== undefined &&
            checkout.refund_url !== "" &&
            checkout.refund_url !== undefined &&
            checkout.contact_url !== "" &&
            checkout.contact_url !== undefined &&
            checkout.recurring_url !== "" &&
            checkout.recurring_url !== undefined
          ) {
            onboardProgress.value = onboardProgress.value + 20;
          }
        } catch (err) {
          onboardProgress.value = onboardProgress.value + 0;
        }
      }
    };
    watch(
      // () => route.path,
      () => store.getters.isUserAuthenticated,
      () => {
        MenuComponent.hideDropdowns(undefined);

        // check if current user is authenticated
        if (!store.getters.isUserAuthenticated) {
          router.push({ name: "sign-in" });
        }

        nextTick(() => {
          reinitializeComponents();
        });
        removeModalBackdrop();
      }
    );
    watch(
      () => getMerchantId.value,
      () => {
        getOnboardProgress();
      }
    );
    watch(
      // () => route.path,
      () => store.getters.isUserAuthenticated,
      () => {
        MenuComponent.hideDropdowns(undefined);

        // check if current user is authenticated
        if (!store.getters.isUserAuthenticated) {
          router.push({ name: "sign-in" });
        }

        nextTick(() => {
          reinitializeComponents();
        });
        removeModalBackdrop();
      }
    );
    const onboardProgress = ref(0);

    const onAction = (val) => {
      showProgress.value = val;
    };

    return {
      data,
      isMerchantAccountPage,
      onboardProgress,
      showProgress,
      onAction,
    };
  },
});
